module.exports = __webpack_public_path__ + "img/ye.71f6118d.svg";